<amplify-authenticator [services]="services" [hideSignUp]="true" [loginMechanisms]="['email']"
  [signUpAttributes]="['name', 'phone_number']">
  <ng-template amplifySlot="sign-in-header">
    <div style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)">
      <div class="pe-2">
        <img class="img-fluid" src="/assets/logo.jpg" />
      </div>
    </div>
    <h2 class="amplify-heading" style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)">
      Sign in to your account
    </h2>
    <p style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)">
      By signing in you have agreed to our <a routerLink="/tandcs">terms and conditions</a>
    </p>
  </ng-template>

  <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
    <div class="d-flex align-items-center flex-column mt-2">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</amplify-authenticator>